import { transportationKeys } from '../../../../../../../consts/conditions';
import { Arithmetic } from './Arithmetic';
import { ChangeDataTypes } from './ChangeDataTypes';
import { CreateColumn } from './CreateColumn';
import { DateShifting } from './DateShifting';
import { DraggableTransformation } from './DraggableTransformation';
import { DuplicateRows } from './DuplicateRows';
import { Join } from './Join';
import { RemoveDuplicates } from './RemoveDuplicates';
import { RenameColumns } from './RenameColumns';
import { SplitByValue } from './SplitByValue';
import { SplitColumn } from './SplitColumn';
import { Substitute } from './Substitute';
import { SumIf } from './SumIf';

const EmptyComponent = () => null;

export const Renderers = {
  [transportationKeys.ABSOLUTE]: EmptyComponent,
  [transportationKeys.REPLACE]: DraggableTransformation,
  [transportationKeys.FILTER]: DraggableTransformation,
  [transportationKeys.FILL_FORWARD]: EmptyComponent,
  [transportationKeys.ADD_COLUMN]: CreateColumn,
  [transportationKeys.REMOVE_DUPLICATES]: RemoveDuplicates,
  [transportationKeys.RENAME_COLUMNS]: RenameColumns,
  [transportationKeys.ARITHMETIC]: Arithmetic,
  [transportationKeys.SPLIT]: SplitColumn,
  [transportationKeys.CONCATENATE]: Arithmetic,
  [transportationKeys.JOIN]: Join,
  [transportationKeys.NEGATIVE]: EmptyComponent,
  [transportationKeys.SUBSTITUTE]: Substitute,
  [transportationKeys.SUM_IF]: SumIf,
  [transportationKeys.DUPLICATE_ROWS]: DuplicateRows,
  [transportationKeys.DATE_SHIFTING]: DateShifting,
  [transportationKeys.CHANGE_DATA_TYPES]: ChangeDataTypes,
  [transportationKeys.SPLIT_BY_VALUE]: SplitByValue
};
